import { render, staticRenderFns } from "./AutoTagRuleEditor.vue?vue&type=template&id=210f8c6c&lang=pug"
import script from "./AutoTagRuleEditor.vue?vue&type=script&lang=ts"
export * from "./AutoTagRuleEditor.vue?vue&type=script&lang=ts"
import style0 from "./AutoTagRuleEditor.vue?vue&type=style&index=0&id=210f8c6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports